// extracted by mini-css-extract-plugin
module.exports = {"section":"SelectSectionCard_section__2Wj8j","selected":"SelectSectionCard_selected__1GZq9"};